export default "__VITE_ASSET__UpdZdeh5__"